import React from 'react';
import * as ExcelJS from 'exceljs';
import { Alerts } from '../common/Alerts';
import { useTranslate } from '../../lib'

const ExcelUploadButton = ({ onQuestionsLoaded, useValueQuestion, style }) => {
  const { t } = useTranslate();
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);

  const generateTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Questions');

    worksheet.columns = [
      { header: 'Question', key: 'question', width: 50 },
      { header: 'Suggested', key: 'suggested', width: 50 },
      { header: 'Value', key: 'value', width: 15 }
    ];

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF4F81BD' }
    };
    worksheet.getRow(1).font = { color: { argb: 'FFFFFFFF' }, bold: true };

    const exampleData = [
      {
        question: "Did the agent introduce themselves properly?",
        suggested: "The agent should state their name and company at the start of the call",
        value: "20"
      },
      {
        question: "Did the agent actively listen and address customer concerns?",
        suggested: "The agent should acknowledge customer points and provide relevant responses",
        value: "25"
      },
      {
        question: "Was the agent professional throughout the interaction?",
        suggested: "The agent should maintain a polite and professional tone throughout",
        value: "25"
      },
      {
        question: "Did the agent provide clear and accurate information?",
        suggested: "Information should be precise and easy to understand",
        value: "30"
      }
    ];

    worksheet.addRows(exampleData);

    for (let i = 2; i <= 5; i++) {
      worksheet.getRow(i).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF2F2F2' }
      };
    }

    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    worksheet.getCell('C1').note = {
      texts: [{
        text: 'The sum of all values must equal 100',
        bold: true
      }],
      protection: {
        locked: true,
        lockText: true
      }
    };

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'questions_template.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    console.log("file", file)
    try {
      setLoading(true);
      setError('');
      setShowAlert(false);
      
      const workbook = new ExcelJS.Workbook();
      const arrayBuffer = await file.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);
      
      const worksheet = workbook.worksheets[0];
      const questions = [];
      console.log("worksheet", worksheet)
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) { // Skip header row
          const question = row.getCell(1).value;
          const suggested = row.getCell(2).value;
          const value = row.getCell(3).value;
          
          if (question) {
            questions.push({
              id: `${rowNumber}-${Date.now()}`,
              question: question.toString(),
              suggested: suggested ? suggested.toString() : '',
              value: value ? value.toString() : "0", // Use the value from Excel if present
              category: "",
              autofail: 0 
            });
          }
        }
      });

      if (questions.length === 0) {
        setError(t('errors.excelNoQuestions'));
        setShowAlert(true);
        return;
      }

      const sum = questions.reduce((acc, q) => acc + parseFloat(q.value || 0), 0);
      if (Math.abs(sum - 100) > 0.01 && useValueQuestion == 1) {
        setError(t('errors.excelSumNot100'));
        setShowAlert(true);
        return;
      }

      onQuestionsLoaded(questions);
    } catch (err) {
      console.error('Error processing Excel file:', err);
      setError(t('errors.excelProcessingError'));
      setShowAlert(true);
    } finally {
      setLoading(false);
      event.target.value = '';
    }
  };

  return (
    <div style={style}>
      <div className="flex items-center space-x-2">
        <button type='button' className="cursor-pointer buttonH upload-excel trans" style={{minWidth: 129}}>
          <img src="/icons/excel.svg" alt="excel" style={{width: 20, marginRight: 10}} />
          <div
            style={{fontSize: 12, display: 'flex', flexDirection: 'row', alignItems: 'center', fontWeight: 600, color: '#1C56B0'}}>
            {loading ? t('menu.processing') : t('menu.uploadExcel')}
            <input
              type="file"
              className=""
              accept=".xlsx,.xls"
              onChange={handleFileUpload}
              style={{fontSize: '12px !important', marginLeft: 10}}
            />
          </div>
        </button>
        <div className="input ml-3">
          <button 
            onClick={generateTemplate}
            className="a-download buttonH trans"
            type="button" style={{color: '#1C56B0', fontSize: 12}}
          >
            <img src="/icons/download-icon.svg" alt="Img Template" style={{width: 15, marginRight: 5}}/>
            {t('menu.downloadTemplate')}
          </button>
        </div>
      </div>
      
      {showAlert && error && (
        <Alerts 
          id="excel-upload-alert" 
          title={error}
          error={true}
        />
      )}
    </div>
  );
};

export default ExcelUploadButton;